/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Ogtitlefallback2Inputs */

const ja_metadata_ogtitlefallback2 = /** @type {(inputs: Metadata_Ogtitlefallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN（株式会社プレイブレーン） | ゲームマーケティング・eスポーツ制作会社`)
};

const en_metadata_ogtitlefallback2 = /** @type {(inputs: Metadata_Ogtitlefallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Japanese Marketing for Games and Production for Esports`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Japanese Marketing for Games and Production for Esports" |
*
* @param {Metadata_Ogtitlefallback2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_ogtitlefallback2 = /** @type {((inputs?: Metadata_Ogtitlefallback2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Ogtitlefallback2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_ogtitlefallback2(inputs)
	return en_metadata_ogtitlefallback2(inputs)
});
export { metadata_ogtitlefallback2 as "metadata_ogTitleFallback" }